import { db } from '@/firebase'
import { PALABRAS_ALLOW_LIST_COLLECTION } from '@/constants/collections'

const palabrasAllowListRef = db.collection(PALABRAS_ALLOW_LIST_COLLECTION)

export const getPalabrasAllowListAddress = async (
  walletAddress,
  roundNumber
) => {
  let response
  let error
  try {
    const snapshot = await palabrasAllowListRef
      .where('walletAddress', '==', walletAddress.toLowerCase())
      .where('roundNumber', '==', parseInt(roundNumber))
      .limit(1)
      .get()
    response = snapshot.docs[0].data()
  } catch (e) {
    error = e
  }

  return { response, error }
}
